// CANONICAL COPY (GH #7115). src/constants/obligations/obl-vendor-assessment.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-vendor-assessment',
  title: 'Perform vendor security assessments',
  description:
    'Complete security assessments for all active vendors. Review assessment responses and risk scores.',
  category: 'vendors',
  scfIds: ['SCF-VDR-004'],
  cadence: { frequency: '1y', anchor: 'domain' },
  strategy: 'all',
  fulfilmentCriteria: [
    { type: 'vendor-assessed', description: 'All vendors have completed assessments' },
    { type: 'vendor-assessment-current', description: 'No vendor assessments are overdue' },
  ],
  domainActions: [{ type: 'deep-link', target: 'vendors', label: 'Review Vendors' }],
};
